import work from "../store/modules/work"
import activity from "../store/modules/activity"

const URLS = {
  // 登录相关
  // 账号、密码登录
  loginCommon: `server/userinfo/login/`,
  // 验证码登录
  loginVerify: `server/userinfo/login_verifycode/`,
  // 忘记密码
  findPassword: `server/userinfo/reset_password/`,
  // 获取验证码，登录
  getVerifyForLogin: username =>
    `server/userinfo/login_request/?username=${username}`,
  // 获取验证码，忘记密码
  getVerifyForFogetPsd: username =>
    `server/userinfo/app_reset_password_request/?username=${username}`,
  // 个人信息
  whoami: `server/userinfo/whoami/`,
  // 他人信息
  userinfo: userid => `server/userinfo/userinfo_with_id/${userid}/`,
  // 退出登录
  logout: `server/userinfo/logout/`,

  /**
   * 七牛token
   */
  qiniu_token: `server/upload/token/`,

  // ----------------------------橙旭园社区 api
  /**
   * 新建帖子 api
   */
  create_post: `server/community/create_post/`,

  /**
   * 帖子列表 api
   */
  list_post: (pagenum, types, user_id, owner, follow_type, company_id, searchValue, is_essence, school_id, page_size) => {
    let url = `server/community/list_post/?page=${pagenum}&ordering=-is_top,-create_time`
    if (types) {
      url += `&types=${types}`
    }
    if (user_id) {
      url += `&user_id=${user_id}`
    }
    if (owner) {
      url += `&owner=${owner}`
    }
    if (follow_type) {
      url += `&follow_type=${follow_type}`
    }
    if (company_id) {
      url += `&company_id=${company_id}`
    }
    if (searchValue) {
      url += `&search=${searchValue}`
    }
    if (is_essence) {
      url += `&is_essence=True`
    }
    if (school_id) {
      url += `&school_id=${school_id}`
    }
    if(page_size){
      url += `&page_size=${page_size}`
    }
    return url
  },

  /**
   * 点赞帖子
   */
  like_post: post => `server/community/like_post/${post}/`,

  /**
   * 取消点赞帖子
   */
  unlike_post: post => `server/community/unlike_post/${post}/`,

  /**
   * 帖子置顶和取消置顶
   */
  sticky_post: post => `server/community/sticky_post/${post}/`,

  /**
   * 帖子加精和取消加精
   */
  essence_post: post_id => `server/community/essence_post/${post_id}/`,

  /**
   * 帖子上首页和取消上首页
   */
  home_video_post: post_id => `server/community/home_video_post/${post_id}/`,

  /**
   * 删除帖子
   */
  delete_post: post => `server/community/delete_post/${post}/`,

  /**
   * 帖子详情
   */
  detail_post: pk => `server/community/detail_post/${pk}/`,

  /**
   * 是否可以发帖
   */
  is_can_send: `server/community/is_can_send`,

  /**
   * 送花
   */
  send_flower: `server/community/send_flower/`,

  /**
   * 转发帖子到朋友圈
   */
  forward_to_common_post: `server/community/forward_to_common_post/`,

  /**
   * 新建帖子的评论 api
   */
  create_comment: `server/community/create_comment/`,

  /**
   * 某个帖子的评论列表 api
   * posts: `帖子的 pk`
   */
  list_comment: (pagenum, post) =>
    `server/community/list_comment/?page=${pagenum}&post=${post}`,

  /**
   * 点赞评论
   */
  like_comment: comment => `server/community/like_comment/${comment}/`,

  /**
   * 取消点赞评论
   */
  unlike_comment: comment => `server/community/unlike_comment/${comment}/`,

  /**
   * 删除评论
   */
  delete_comment: comment => `server/community/delete_comment/${comment}/`,

  /**
   * 某个评论的回复列表 api
   */
  list_reply: (pagenum, comment_id) => `server/community/list_reply/?page=${pagenum}&comment=${comment_id}`,

  /**
   * 新建评论的回复 api
   */
  create_reply: `server/community/create_reply/`,

  /**
   * 点赞回复
   */
  like_reply: reply => `server/community/like_reply/${reply}/`,

  /**
   * 取消点赞回复
   */
  unlike_reply: reply => `server/community/unlike_reply/${reply}/`,

  /**
   * 删除回复
   */
  delete_reply: reply => `server/community/delete_reply/${reply}/`,

  /**
   * 新建公告栏 api
   */
  create_bullet_board: `server/community/create_bullet_board/`,

  /**
   *  公告栏列表 api
   */
  list_bullet_board: `server/community/list_bullet_board/`,

  /**
   * 我的作品 api
   */
  list_myworks: (pagenum, user_id, owner, work_type, top, page_size) => {
    let url = `server/job_management/list_showwork/?page=${pagenum}`;
    if (user_id) {
      url += `&user_id=${user_id}`
    }
    if (owner) {
      url += `&owner=${owner}`
    }
    if (work_type) {
      url += `&work_type=${work_type}`
    }
    if (top) {
      url += `&top=True`
    }
    if (page_size) {
      url += `&page_size=${page_size}`
    }
    return url
  },

  /**
   * 点赞作品 api
   */
  like_work: `server/show/showwork_like_or_cancel/`,

  /**
   * 删除作品
   */
  delete_showwork: pk => `server/job_management/delete_showwork/${pk}/`,

  /**
   * 我的帖子列表 api
   */
  list_myposts: (pagenum, user_id) =>
    `server/community/list_post/?page=${pagenum}&user_id=${user_id}`,

  /**
   * 消息列表
   * pagenum: 分页
   * type: create 或者 like，消息类型(评论消息或点赞消息)
   * user_type: receiver 或 sender，用户类型(收到的消息或发出的消息)
   * user: 用户的账号
   */
  list_message: (pagenum, type, user_type, user) => {
    let url = `server/community/list_message/?page=${pagenum}`
    if (type) {
      url += `&type=${type}`
    }
    if (user_type === 'receiver') {
      url += `&tag=receive`
    } else if (user_type === 'sender') {
      url += `&tag=send`
    }

    // if (user_type === 'receiver' && user) {
    //   url += `&receiver=${user}`
    // } else if (user_type === 'sender' && user) {
    //   url += `&sender=${user}`
    // }

    return url
  },

  /**
   * 删除消息
   */
  delete_message: pk => `server/community/delete_message/${pk}/`,

  /**
   * 我的未读消息个数
   */
  my_unread_message: user_id => {
    let url = `server/community/my_unread_message/?`
    if (user_id) {
      url += `user_id=${user_id}`
    }
    return url
  },

  /**
   * 关注
   */
  add_follows: `server/community/add_followers/`,

  /**
   * 取关
   */
  remove_follows: `server/community/remove_followers/`,

  /**
   * 声望排行榜
   */
  list_rank: tag => `server/community/list_rank/?tag=${tag}`,

  /**
   * 社区每日游玩时间
   */
  day_play_time: `server/community/day_play_time/`,

  /**
   * 新建公司
   */
  create_company: `server/company/create_company/`,

  /**
   * 公司等级下具体数据
   */
  list_company_type: (pagenum, grade_id) => {
    let url = `server/company/list_company/?page=${pagenum}`
    if (grade_id) {
      url += `&grade_id=${grade_id}`
    }
    return url
  },

  /**
   * 公司首页列表请求
   */
  list_company_data:`/server/company/list_grade/`,

  /**
  * 公司详情
  */
  detail_company: pk => `server/company/detail_company/${pk}/`,

  /**
   * 公司修改
   */
  update_company: pk => `server/company/update_company/${pk}/`,

  /**
   * 加入公司
   */
  join_company: `server/company/join_company/`,

  /**
   * 离开公司
   */
  quit_company: `server/company/quit_company/`,

  /**
   * 解散公司
   */
  delete_company: pk => `/server/company/delete_company/${pk}/`,

  /**
   * 公司成员列表
   */
  list_member_company: (pagenum, company) => {
    let url = `server/company/list_member/?page=${pagenum}&page_size=50`
    if (company) {
      url += `&company=${company}`
    }
    return url
  },

  /**
   * 修改公司成员职位
   * */
  update_member_job: pk => `/server/company/update_member/${pk}/`,

  /**
   * 公司产品列表
   */
  list_product_company: (pagenum, company) => {
    let url = `server/company/list_product/?page=${pagenum}`
    if (company) {
      url += `&company=${company}`
    }
    return url
  },

  /**
   * 公司产品列表（全部产品，为公司人员提供）
   */
  list_product_company_inside: pagenum => `/server/company/list_product/?page=${pagenum}`,

  /**
   * 新建公司产品
   */
  create_product_company: `server/company/create_product/`,

  /**
   * 购买公司产品
   */
  create_product_company_order: `server/company/create_order/`,

  /**
   * 公司收入排行榜
   */
  list_rank_company: `server/company/list_rank/`,

  /**
   * 公司 CEO给员工发工资
   */
  pay_member: `server/company/pay_member/`,

  /**
   * 我购买的作品
   */
  my_buy_works: (pagenum, user_id) => {
    let url = `server/company/my_orders/?page=${pagenum}`
    if (user_id) {
      url += `&user_id=${user_id}`
    }
    return url
  },

  /**
   * 作品秀，精选列表
   */
  show_work_top: (pagenum, work_type) => `server/show/showworks/?page=${pagenum}&page_size=100&work_type=${work_type}&top=True`,

  /**
   * 帖子答题事件
   */
  create_post_answer_record: `server/community/create_post_answer_record/`,

  /**
   * 距离上次浏览的帖子，新增帖子的条数
   */
  new_add_post_count: `server/community/new_add_post_count/`,

  /**
   * 下架公司产品
   */
  remove_company_product: 'server/company/remove_product/',

  /**
   * @用户列表
   */
  list_attention_user: (pagenum, name) => `server/job_management/list_attention_user/?page=${pagenum}&search=${name}`,

  /**
   * 我的公司
   */
  my_company: `server/company/my_company/`,


  /**
   * 获取我的证书
  */
  show_my_certificate:(pagenum,certificate_id) => {
    let url = `/server/certificate/list_mycertificate/?page=${pagenum}`
    if(certificate_id){
      url += `&user_id=${certificate_id}`
    }
    return url
  },



  /**
   * 我的关注、粉丝列表
   */
  list_follower: (pagenum, type, user_id, username) => {
    let url = `server/community/list_myfollower/?page=${pagenum}&page_size=50&type=${type}`
    if (user_id) {
      url += `&user_id=${user_id}`
    }
    if (username) {
      url += `&username=${username}`
    }
    return url
  },

  /**
   * 是否是我的在读学员
   */
  is_my_student: user_id => `server/community/myfollower/update_is_my_student/?user_id=${user_id}`,

  /**
   * 视频课程列表 types: 'game'/'teach'
   */
  list_video_course: (pagenum, types) => {
    let url = `server/community/list_video_course/?page=${pagenum}`
    if (types) {
      url += `&types=${types}`
    }
    return url
  },

  /**
   * 视频课程详情
   */
  detail_video_course: pk => `server/community/detail_video_course/${pk}/`,

  /**
   * 视频课程（某一分类下）
   */
  course_videos: (pagenum, category_id) => {
    let url = `server/course/videos/?page=${pagenum}`
    if (category_id) {
      url += `&category=${category_id}`
    }
    return url
  },

  /**
   * 视频课程分类列表
   */
  course_video_categorys: `server/course/video/category/?is_community=true`,

  /**
   * 视频课程详情
   */
  course_video_detail: pk => `server/course/videos/${pk}/`,

  /**
   * 乐高视频分类列表
   */
  lego_video_categorys: `server/course/video/category/?is_lego=true`,
  /**
   * 广告列表
   */
  list_ad: (pagenum, page_size, is_community) => {
    let url = `server/community/list_ad/?page=${pagenum}`
    if(page_size){
      url += `&page_size=${page_size}`
    }
    if(is_community){
      url += `&is_community=${is_community}`
    }
    return url
  },
  
  /**
   * 活动列表
   */
  list_activity: pagenum => `server/contest/activity/?page=${pagenum}&activity_type=activity_circle`,
  /**
   * 活动详情
   */
  detail_activity: number => `server/contest/activity_detail/${number}/`,

  activity_works: (pagenum, number, work_type) => {
    let url = `/server/show/activity/${number}/showworks/?page=${pagenum}`
    if (work_type) {
      url += `&work_type=${work_type}`
    }
    return url
  },

  /**
   * 活动报名
   */
  apply_activity_record: number => `server/contest/apply_activity_record/${number}/`,

  /**
   * 新建学校
   */
  create_school: `server/mentor/create_school/`,

  /**
   * 我的学校
   */
  my_school: `server/mentor/my_school/`,

  /**
   * 加入学校
   */
  join_school: `server/mentor/join_school/`,

  /**
   * 退出学校
   */
  quit_school: `server/mentor/quit_school/`,

  /**
   * 解散学校
   */
  delete_school: pk => `server/mentor/delete_school/${pk}/`,

  /**
   * 学校列表
   */
  list_school: pagenum => `server/mentor/list_school/?page=${pagenum}`,

  /**
   * 学校详情
   */
  detail_school: pk => `server/mentor/detail_school/${pk}/`,

  /**
   * 学校修改
   */
  update_school: pk => `server/mentor/update_school/${pk}/`,

  /**
   * 学校成员列表
   */
  list_member_school: (pagenum, school) => {
    let url = `server/mentor/list_member/?page=${pagenum}&page_size=50&position=apprentice`
    if (school) {
      url += `&school=${school}`
    }
    return url
  },

  /**
   * 学校产品列表
   */
  list_product_school: (pagenum, school) => {
    let url = `server/mentor/list_product/?page=${pagenum}`
    if (school) {
      url += `&school=${school}`
    }
    return url
  },

  /**
   * 活动视频列表
   */
  activity_videos: (activity_nmber, pagenum) => `server/course/activity/${activity_nmber}/videos/?page=${pagenum}`,

  /**
   * 活动视频新建
   */
  activity_videos_create: (activity_number) => `server/course/activity/${activity_number}/videos_create/`,

  /**
   * 用户是否可进入社区
   */
  has_access_user_schedule: `server/community/has_access_user_schedule/`,

  /**
   * 地址列表
   */
  list_address: `server/userinfo/addresses/`,

  /**
   * 修改地址[默认第一条，没有则新建]
   */
  update_address: `server/userinfo/address_update/`,

  /**
   * 获取我的勋章
   */
  get_my_medals:(owner,page_size=100) => `server/community/my_medals/?owner=${owner}&page_size=${page_size}`,

  /**
   * scratch文件上传地址
   */
   upload_zip_scratch_pic: `server/zip_scratchfile/post_zip_scratch_pic/`,

  /**
   * 获得我的scratch打包记录
   */
  get_my_zip_scratch:(pagenum) => `server/zip_scratchfile/list_my_zip_scratch/?page=${pagenum}`,

  /**
   * 获得Disney活动文件列表
   */
  get_my_disney_file_list: (pagenum, is_finish) => `server/zip_scratchfile/get_transform_pic_list/?page=${pagenum}&is_finish=${is_finish}&page_size=5`,

  /**
   * 新建Disney活动记录
   */
  create_disney_file_record: `server/zip_scratchfile/create_transform_pic_record/`,
}

export { URLS }
